import { render, staticRenderFns } from "./EventRegistrationDetailTableForm.vue?vue&type=template&id=cb7ca3ec"
import script from "./EventRegistrationDetailTableForm.vue?vue&type=script&lang=js"
export * from "./EventRegistrationDetailTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports